var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikelihoodAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 125,
    viewBox: "0 0 32 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3542_7629)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    stroke: "#6A6E85",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 111,
    width: 12,
    height: 12,
    rx: 6,
    stroke: "#6A6E85",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28,
    transform: "translate(0 49)",
    fill: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 71.9998C15.2098 71.9998 14.5737 71.3618 14.5804 70.576L14.5804 65.3509L7.0067 60.6026L7 58.702L14.5737 61.0862L14.5737 55.8476L12.6786 54.4305L12.6853 53L15.9933 53.9537L19.3147 53L19.3281 54.4372L17.4062 55.8678V61.066L25 58.702L24.9933 60.6026L17.4196 65.3509L17.4196 70.576C17.433 71.3416 16.7634 72.0132 16 71.9998Z",
    fill: "#6A6E85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 25,
    r: 2,
    fill: "#6A6E85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 34,
    r: 2,
    fill: "#6A6E85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 43,
    r: 2,
    fill: "#6A6E85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 82,
    r: 2,
    fill: "#6A6E85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 91,
    r: 2,
    fill: "#6A6E85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 100,
    r: 2,
    fill: "#6A6E85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3542_7629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 125,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikelihoodAirplane);
export default __webpack_public_path__ + "static/media/likelihood_airplane.2783198dac3dd7ae8b22d33efb07b8b5.svg";
export { ForwardRef as ReactComponent };